import { cornType } from '@eigtech/shared-corn';
import { z } from 'zod';
export const documentResourceType = 'document';
export const documentsServiceCorn = (eventName) => cornType('documents', eventName);
export const DocumentsServiceCornSchema = documentsServiceCorn();
export const DocumentParameterSchema = z.enum(['DOCUMENTS_BASE_URL']);
export const DocumentParameterEnum = DocumentParameterSchema.enum;
